import styled from '@emotion/styled'
import { selectContrastingColor } from '@classy/campaign-page-blocks'
import { breakpointMaxQuery } from 'utils/functions/breakpoints'

export const Outer = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  background: white;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  border-left: 1px #eeeeee solid;
`

export const Header = styled.div<{ withBorder: boolean }>`
  display: flex;
  align-items: center;
  padding: 20px 24px;
  justify-content: flex-end;
  border-bottom: #eeeeee;
  ${({ withBorder }) => (withBorder ? { borderWidth: '1px' } : { borderWidth: 0 })};
`

export const HeaderTitle = styled.div`
  flex: 1;
  font-weight: bold;
`

export const HeaderClose = styled.button`
  cursor: pointer;
  border-radius: 100%;
  border: none;
  width: 28px;
  height: 28px;
  padding: 0;

  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
`

export const Body = styled.div`
  flex: 1;
  padding: 24px;
  overflow-y: auto;
`

export const Footer = styled.div<{ isMobileView?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  padding: 24px;

  ${({ isMobileView }) =>
    isMobileView
      ? `
        flex-direction: column-reverse;
      `
      : ''}

  ${breakpointMaxQuery('xs')} {
    flex-direction: column-reverse;
  }
`

export const FooterAction = styled.button<{ isMobileView?: boolean }>`
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  border-radius: 48px;
  padding: 6px 34px;
  border: 1px solid #ccc;
  font-weight: 500;
  background-color: ${(props) => props.color || 'transparent'};
  color: ${(props) => selectContrastingColor(props.color) || 'buttonText'};
  opacity: ${({ disabled }) => (disabled ? '0.65' : '1')};
  transition: all 0.25s ease-in-out;

  &:hover {
    transform: ${({ disabled }) => (disabled ? 'none' : 'translateY(-1px) scale(1.02)')};
    filter: ${({ disabled }) => (disabled ? 'none' : 'brightness(.96)')};
  }

  &:active {
    transform: ${({ disabled }) => (disabled ? 'none' : 'translateY(0px) scale(0.98)')};
    filter: ${({ disabled }) => (disabled ? 'none' : 'brightness(1)')};
  }

  ${({ isMobileView }) =>
    isMobileView
      ? `
        padding: 18px;
        border-radius: 48px;
        width: 100%;
      `
      : ''}

  ${breakpointMaxQuery('xs')} {
    padding: 18px;
    border-radius: 48px;
    width: 100%;
  }
`
